export default [
	{
	  name: 'G1_V2',
	  start: '0:00.000',
	  end: '1:09.329',
	  duration: '1:09.329',
	  level: '1',
	  is_focus: { fr: true, en: false },
	  position: { x: 1.123, y: 1.555, z: -4.193 },
	},
	{
	  name: 'G1_V1',
	  start: '2:00.000',
	  end: '4:10.896',
	  duration: '2:10.896',
	  level: '1',
	  is_focus: { fr: false, en: true },
	  position: { x: -2.165, y: 1.509, z: -5.118 },
	},
	{
	  name: 'G1_V3',
	  start: '4:30.000',
	  end: '5:34.261',
	  duration: '1:04.261',
	  level: '1',
	  is_focus: { fr: false, en: false },
	  position: { x: -5.574, y: 1.648, z: 9.807 },
	},
	{
	  name: 'G1_V4',
	  start: '6:00.000',
	  end: '7:45.585',
	  duration: '1:45.585',
	  level: '1',
	  is_focus: { fr: false, en: false },
    position: { x: -9.295, y: 1.937, z: -9.759 },
	},
	{
	  name: 'G2_V1',
	  start: '8:30.000',
	  end: '9:54.854',
	  duration: '1:24.854',
	  level: '2',
	  is_focus: { fr: true, en: false },
    position: { x: -7.843, y: 1.511, z: -9.744 },
	},
	{
	  name: 'G2_V2',
	  start: '10:30.000',
	  end: '11:22.037',
	  duration: '0:52.037',
	  level: '2',
	  is_focus: { fr: false, en: true },
	  position: { x: -11.155, y: 1.679, z: -3.204 },
	},
	{
	  name: 'G2_V3',
	  start: '12:00.000',
	  end: '13:13.975',
	  duration: '1:13.975',
	  level: '2',
	  is_focus: { fr: false, en: false },
    position: { x: -9.882, y: 1.671, z: 3.802 },
	},
	{
	  name: 'G2_V4',
	  start: '13:30.000',
	  end: '15:10.678',
	  duration: '1:40.678',
	  level: '2',
	  is_focus: { fr: false, en: false },
    position: { x: 6.720, y: 1.640, z: 2.532 },
	},
	{
	  name: 'G4_V4',
	  start: '15:30.000',
	  end: '16:24.766',
	  duration: '0:54.766',
	  level: '3',
	  is_focus: { fr: true, en: false },
	  position: { x: 6.480, y: 1.598, z: 4.573 },
	},
	{
	  name: 'G4_V2',
	  start: '17:00.000',
	  end: '17:57.110',
	  duration: '0:57.110',
	  level: '3',
	  is_focus: { fr: false, en: true },
    position: { x: -10.264, y: 1.627, z: -0.126 },
	},
	{
	  name: 'G4_V1',
	  start: '18:30.000',
	  end: '19:13.512',
	  duration: '0:43.512',
	  level: '3',
	  is_focus: { fr: false, en: false },
    position: { x: 6.516, y: 1.428, z: 0.457 },
	},
	{
	  name: 'G4_V3',
	  start: '20:00.000',
	  end: '20:31.608',
	  duration: '0:31.608',
	  level: '3',
	  is_focus: { fr: false, en: false },
    position: { x: -1.242, y: 1.440, z: -8.321 },
	},
	{
	  name: 'G3_V1',
	  start: '21:00.000',
	  end: '22:05.456',
	  duration: '1:05.456',
	  level: '4',
	  is_focus: { fr: true, en: false },
    position: { x: -8.632, y: 1.616, z: -4.952 },
	},
	{
	  name: 'G3_V2',
	  start: '22:30.000',
	  end: '23:38.669',
	  duration: '1:08.669',
	  level: '4',
	  is_focus: { fr: false, en: true },
    position: { x: -7.078, y: 1.765, z: 7.254 },
	},
	{
	  name: 'G3_V3',
	  start: '24:00.000',
	  end: '25:04.353',
	  duration: '1:04.353',
	  level: '4',
	  is_focus: { fr: false, en: false },
    position: { x: 2.624, y: 2.022, z: -5.861 },
	},
	{
	  name: 'G3_V4',
	  start: '25:30.000',
	  end: '26:27.840',
	  duration: '0:57.840',
	  level: '4',
	  is_focus: { fr: false, en: false },
    position: { x: 5.869, y: 1.597, z: 6.084 },
	},
	{
	  name: 'G6_V3',
	  start: '27:00.000',
	  end: '28:35.282',
	  duration: '1:35.282',
	  level: '5',
	  is_focus: { fr: true, en: false },
    position: { x: 7.980, y: 1.721, z: -3.805 },
	},
	{
	  name: 'G6_V1',
	  start: '29:00.000',
	  end: '30:08.583',
	  duration: '1:08.583',
	  level: '5',
	  is_focus: { fr: false, en: true },
    position: { x: -7.499, y: 1.85, z: 5.403 },
	},
	{
	  name: 'G6_V2',
	  start: '31:00.000',
	  end: '32:22.165',
	  duration: '1:22.165',
	  level: '5',
	  is_focus: { fr: false, en: false },
    position: { x: -3.505, y: 1.395, z: -3.456 },
	},
	{
	  name: 'G6_V4',
	  start: '33:00.000',
	  end: '34:44.397',
	  duration: '1:44.397',
	  level: '5',
	  is_focus: { fr: false, en: false },
    position: { x: -4.512, y: 1.578, z: 11.964 },
	},
	{
	  name: 'G5_V1',
	  start: '36:00.000',
	  end: '36:45.893',
	  duration: '0:45.893',
	  level: '6',
	  is_focus: { fr: true, en: false },
    position: { x: 3.319, y: 1.215, z: 13.693 },
  },
  {
	  name: 'G5_V2',
	  start: '38:00.000',
	  end: '38:56.379',
	  duration: '0:56.379',
	  level: '6',
	  is_focus: { fr: false, en: true },
    position: { x: -5.887, y: 1.646, z: 8.710 },
	},
	{
	  name: 'G5_V3',
	  start: '40:00.000',
	  end: '41:10.192',
	  duration: '1:10.192',
	  level: '6',
	  is_focus: { fr: false, en: true },
    position: { x: -5.763, y: 1.569, z: 3.414 },
	},
	{
	  name: 'G5_V4',
	  start: '42:00.000',
	  end: '44:43.389',
	  duration: '2:43.389',
	  level: '6',
	  is_focus: { fr: false, en: false },
    position: { x: -10.445, y: 1.663, z: 6.314 },
	},
	{
	  name: 'G8_V3',
	  start: '45:00.000',
	  end: '45:54.106',
	  duration: '0:54.106',
	  level: '7',
	  is_focus: { fr: true, en: false },
    position: { x: 6.320, y: 1.653, z: 9.572 },
	},
	{
	  name: 'G8_V1',
	  start: '46:00.000',
	  end: '47:43.703',
	  duration: '1:43.703',
	  level: '7',
	  is_focus: { fr: false, en: true },
	  position: { x: -3.770, y: 1.861, z: 16.517 },
	},
	{
	  name: 'G8_V2',
	  start: '48:00.000',
	  end: '49:44.833',
	  duration: '1:44.833',
	  level: '7',
	  is_focus: { fr: false, en: false },
      position: { x: 4.378, y: 1.576, z: -6.365 },
	},
	{
	  name: 'G8_V4',
	  start: '50:00.000',
	  end: '50:42.086',
	  duration: '0:42.086',
	  level: '7',
	  is_focus: { fr: false, en: false },
   	  position: { x: 0.991, y: 1.728, z: 12.602 },
	},
	{
	  name: 'G7_V3',
	  start: '51:30.000',
	  end: '52:01.617',
	  duration: '0:31.617',
	  level: 'explore',
	  is_focus: { fr: false, en: false },
    position: { x: 9.500, y: 1.552, z: -0.743 },
	},
	{
	  name: 'G7_V1',
	  start: '52:30.000',
	  end: '53:21.293',
	  duration: '0:51.293',
	  level: 'explore',
	  is_focus: { fr: false, en: false },
    position: { x: 7.675, y: 1.853, z: 13.385 },
	},
	{
	  name: 'G7_V2',
	  start: '53:30.000',
	  end: '54:39.067',
	  duration: '1:09.067',
	  level: 'explore',
	  is_focus: { fr: false, en: false },
    position: { x: -8.543, y: 1.642, z: -7.638 },
	},
]





// WEBPACK FOOTER //
// ./src/components/music/music/captations.js